import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: import.meta.env.FOOJI_GOOGLE_API_KEY as string,
  version: "weekly",
  libraries: ["places"]
});

export const loadPlaces = () => loader.importLibrary("places");
export const loadMaps = () => loader.importLibrary("maps");
export const loadCore = () => loader.importLibrary("core");
export const loadMarkers = () => loader.importLibrary("marker");
